import { Checkbox, Container, Typography } from '@cleartrip/ct-design-components'
import React, { FC, useEffect, useState } from 'react'
import { isUserSignedIn } from '@/utils/general/user'
import { getCookie } from '@/utils/general/cookie'
import { ravenSDKTrigger } from '@/analytics/raven/ravenSDKHelper'
import CfwCheckboxTooltip from './CfwCheckboxTooltip'
import { useRouter } from 'next/router'
import BorderAnimation from './BorderAnimation'
import styles from './cfwBanner.module.scss'

type HomeFormType = {
    setCfwErrorModalButtonText: (value: string) => void
    setCfwErrorModal: (value: string) => void
    activeFare: String
    isIntl: boolean
    setIsCfwSelected: (value: boolean) => void
    isCfwSelected: boolean
    setCfwModal: (value: boolean) => void
    variant?: 'home' | 'srp'
    isThemed?: boolean
}
const CFWHomePageCallout: FC<HomeFormType> = ({
    setCfwErrorModalButtonText,
    setCfwErrorModal,
    activeFare,
    isIntl,
    setIsCfwSelected,
    isCfwSelected,
    setCfwModal,
    variant = 'home',
    isThemed = false
}) => {
    const route = useRouter()
    const [calloutIndex, setCalloutIndex] = useState(0)

    const spoofMessages = [
      { description: "Unlock 10% extra savings" },
      { description: "Low or Zero Cancellation Charges" },
      { description: "Free* seats & meals" },
      { description: "GST Invoice Assurance" }
    ];

    const onCheckboxClick = () => {
        setCfwErrorModalButtonText('Switch to Cleartrip for Work')

        if (activeFare === 'senior_citizen') {
            setCfwErrorModal('Cleartrip for Work doesn’t include the benefits of Senior citizen fare')
            return
        } else if (activeFare === 'student') {
            setCfwErrorModal('Cleartrip for Work doesn’t include the benefits of Student fare')
            return
        } else if (activeFare === 'army') {
            setCfwErrorModal('Cleartrip for Work doesn’t include the benefits of Armed forces fare')
            return
        }

        const ravenPayloadForCfwClick = {
            action_name: isCfwSelected ? 'cfw_widget_checkbox_uncheck_click' : 'cfw_widget_checkbox_click',
            action_type: 'click',
            page_name: 'flights_home',
            a_utm_source:
                location?.search?.split?.('utm_source=').length > 1
                    ? location?.search?.split?.('utm_source=')?.pop()?.split('&')?.[0]
                    : getCookie('utm_source') || 'organic'
        }

        ravenSDKTrigger('a_ui_action', ravenPayloadForCfwClick)

        if (!isCfwSelected) {
            let cfwHomepageBannerClicksCount = localStorage.getItem('cfwHomepageBannerClicksCount') || 0
            localStorage.setItem('cfwHomepageBannerClicksCount', String(Number(cfwHomepageBannerClicksCount) + 1))
            if (Number(cfwHomepageBannerClicksCount) < 5) {
                setCfwModal(true)
            }
        }
        setIsCfwSelected(!isCfwSelected)
    }
    useEffect(() => {
        if (variant === 'home') {
            if (isUserSignedIn()) {
                setIsCfwSelected(true)
            }
        }
        if(route?.query?.['airCFW-reactivation'] === 'true'){
                setIsCfwSelected(true)
        }
        
    }, [isUserSignedIn, variant])

    useEffect(() => {
        if (!spoofMessages?.length) return;
    
        // When we've scrolled to the cloned first item, wait for the
        // transition to finish (400ms) then snap back to index 0 instantly.
        if (calloutIndex === spoofMessages.length) {
          const timeout = setTimeout(() => {
            setCalloutIndex(0);
          }, 300);
          return () => clearTimeout(timeout);
        }
    
        // Otherwise, advance to the next callout every 3 seconds.
        const id = setInterval(() => {
          setCalloutIndex((i) => i + 1);
        }, 2000);
        return () => clearInterval(id);
      }, [calloutIndex, spoofMessages?.length]);

    return (
        <Container className="p-relative" style={{ flexShrink: 0 }}>
            <CfwCheckboxTooltip isIntl={isIntl}/>
            <BorderAnimation className="br-6" startAnimation={true}>
                <Container
                    className="flex flex-middle"
                    style={{
                        padding: '8px',
                        cursor: 'pointer',
                        opacity: 1,
                        // Themed cabins: blue brand tint on a solid white base (stays opaque on the hero).
                        background: isThemed
                            ? 'linear-gradient(74.66deg, rgba(255, 255, 255, 0) 3%, rgba(188, 213, 255, 0.6) 98.19%), #FFFFFF'
                            : 'linear-gradient(88deg, rgba(255, 255, 255, 0.00) 3%, rgba(188, 213, 255, 0.60) 98.19%)'

                    }}
                    onClick={onCheckboxClick}
                >
                    <Checkbox checked={isCfwSelected} />
                    <Container className={`flex flex-column ${styles.textBlock}`}>
                        <Typography variant="B3">
                            Business Fares by Cleartrip
                        </Typography>
                        <Container className="o-hidden" style={{ height: '16px' }}>
                          <Container
                            className="flex flex-column"
                            style={{
                              transform: `translateY(-${calloutIndex * 16}px)`,
                              transition: calloutIndex === 0 ? 'none' : 'transform 0.3s ease-in-out',
                            }}
                          >
                            {[...spoofMessages, spoofMessages[0]]?.map(({ description }, idx) => (
                              <Typography
                                  key={`cfw-callout-${idx}-${description}`}
                                  style={{ lineHeight: '16px' }}
                                  variant="B4"
                                  color="success"
                              >
                                  {description}
                              </Typography>
                            ))}
                          </Container>
                        </Container>
                    </Container>
                    <Container
                        className={`flex flex-middle flex-center ml-2 px-2 py-1 fs-10 fw-600 br-4 ${styles['clear-orange-bg']} ${styles['color-white']} ${styles.saveMoreButton}`}
                    >
                        SAVE MORE
                    </Container>
                </Container>
            </BorderAnimation>
        </Container>
    )
}

export default CFWHomePageCallout
